import { memo } from "react";
import Modal from "ui/atoms/Modal";
import { useWaMessageSetupContext } from "./WaMessageSetupProvider";
import WaMessageSetupView from "./WaMessageSetupView";
import WaMessageSetupForm from "./WaMessageSetupForm";

const TITLE_BY_MODE = {
    view: 'View Message Setup',
    edit: 'Edit Message Setup',
    create: 'Create Message Setup'
} as const;

const WaMessageSetupDetail = () => {
    const { open, mode, resource, onClose } = useWaMessageSetupContext();

    const title = mode ? TITLE_BY_MODE[mode] : '';

    return (
        <Modal
            isOpen={open}
            disableCloseOnBackdropClick
            titleSlot={title}
            onClose={onClose}
            DialogProps={{
                sx: {
                    '& .MuiPaper-root': {
                        maxWidth: 750
                    }
                }
            }}
        >
            {mode === 'view' && resource && (
                <WaMessageSetupView resource={resource} />
            )}
            {(mode === 'edit' || mode === 'create') && (
                <WaMessageSetupForm resource={resource} />
            )}
        </Modal>
    );
};

export default memo(WaMessageSetupDetail);
